module.exports = {"gender":{"male":10,"female":2},"age_range":{"0-17":3,"18-24":0,"25-34":15,"35-44":2,"45-54":0,"55-64":1,"65+":35},"returning":{"time5":10,"time2+":3,"time6+":3,"time3":1},"Department":[{"id":-1,"count":40},{"id":14,"count":2},{"id":15,"count":24}]}


//////////////////
// WEBPACK FOOTER
// ./src/_mockup/stress_report_select_1.json
// module id = 1877
// module chunks = 0